import {GenOutageErrorParent} from 'generated/serverModels/GenOutageErrorParent';

export class UtilityErrorParent extends GenOutageErrorParent {
    public percentRepeated: number;

    constructor(input?: UtilityErrorParent) {
        super(input);
    }
}
